// extracted by mini-css-extract-plugin
export default {"heading":"Ym-z","createAccount":"Zm-z","disabled":"_m-z","copy":"an-z","terms":"bn-z"};